import React from 'react';
import appleBadge from 'assets/images/thirdParty/appleBadge.png';
import googleBadge from 'assets/images/thirdParty/googleBadge.png';

type AppStoreButtonsProps = {
  iosUrl?: string;
  androidUrl?: string;
};

/**
 * Store badges for one app. A store without a URL yet still renders its badge,
 * as a plain element rather than a link — it looks the same but does nothing,
 * so nothing on the page pretends to be a working link.
 */
const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
  iosUrl,
  androidUrl,
}) => {
  return (
    <div className="store-buttons">
      {iosUrl ? (
        <a
          className="store-button"
          href={iosUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={appleBadge} alt="" className="store-button-icon" />
          <span>Get on iOS</span>
        </a>
      ) : (
        <span className="store-button">
          <img src={appleBadge} alt="" className="store-button-icon" />
          <span>Get on iOS</span>
        </span>
      )}

      {androidUrl ? (
        <a
          className="store-button"
          href={androidUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={googleBadge} alt="" className="store-button-icon" />
          <span>Get on Android</span>
        </a>
      ) : (
        <span className="store-button">
          <img src={googleBadge} alt="" className="store-button-icon" />
          <span>Get on Android</span>
        </span>
      )}
    </div>
  );
};

export default AppStoreButtons;
